import { render, staticRenderFns } from "./VuePersianDatetimePicker.vue?vue&type=template&id=77844950&"
import script from "./VuePersianDatetimePicker.vue?vue&type=script&lang=js&"
export * from "./VuePersianDatetimePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports